
import TrainerRoutes from '../UserRoutes/TrainerRoutes'
import '../../../styles/userStyles/Trainer.css'
function Content() {
    return (
        <div className="trainer--content"><TrainerRoutes /></div>
    )
}

export default Content